export default function initUnsavedFormHandler() {
    document.addEventListener("alpine:init", () => {
        Alpine.data("unsavedFormHandler", () => ({
            isDirty: false,

            markAsDirty() {
                this.isDirty = true;
            },

            markAsClean() {
                this.isDirty = false;
            },

            init() {
                window.addEventListener("beforeunload", (event) => {
                    if (this.isDirty) {
                        event.preventDefault();
                        event.returnValue = "";
                    }
                });

                window.addEventListener("visibilitychange", () => {
                    if (document.visibilityState === "hidden" && this.isDirty) {
                        alert("Mentetlen adatok vannak az oldalon!");
                    }
                });
            },
        }));
    });
}
